import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 9l3 3l-3 3","key":"svg-0"}],["path",{"d":"M13 15h3","key":"svg-1"}],["path",{"d":"M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10","key":"svg-2"}]]

const IconBrandTabler = createReactComponent('outline', 'brand-tabler', 'BrandTabler', __iconNode);

export default IconBrandTabler;